export default __webpack_public_path__ + "static/media/MaskGroup-1.27620e0c.svg";